import React from 'react'
import SkeletonBlock from './SkeletonBlock'

/**
 * Single-line text placeholder. Defaults to ~14px tall (typical body line).
 * Pass width via className: <SkeletonText className="w-32" />.
 */
function SkeletonText({ className = '', height = 'h-3.5' }) {
  return <SkeletonBlock className={`${height} rounded ${className}`} />
}

export default SkeletonText
